export default __webpack_public_path__ + "static/media/divider.d1080a7e.svg";